import { BASE_DELAY, MAX_DELAY } from '#context/sse/common/constants';

/**
 * Calculates the delay (in milliseconds) before attempting to reconnect,
 * using exponential backoff with jitter. The delay increases exponentially
 * with each attempt, up to a maximum value, and includes a random jitter
 * to prevent reconnection storms.
 *
 * @param attempt - The current reconnection attempt number (starting from 0).
 * @returns The calculated delay in milliseconds before the next reconnection attempt.
 */
export function calculateReconnectDelay(attempt: number) {
  const jitter = Math.random() * 500;

  return Math.min(BASE_DELAY * 2 ** attempt, MAX_DELAY) + jitter;
}
